import { render } from "./index.vue?vue&type=template&id=6347b39d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=6347b39d&scoped=true&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6347b39d"],['__file',"src/components/Tag/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6347b39d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6347b39d', __exports__)) {
    console.log('reload')
    api.reload('6347b39d', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=6347b39d&scoped=true", () => {
    console.log('re-render')
    api.rerender('6347b39d', render)
  })

}


export default __exports__